
const crudFields = [
  {
    key: 'name',
    label: 'Nome',
    required : true
  },
  {
    key: 'description',
    label: 'Descrizione',
    required : false,
  },
  {
    key: 'type',
    label: 'Tipo di associazione',
    type : 'enum',
    component : 'select',
    required : true,
    values : [{label : 'Impianto', value : 'plant'},{label : 'Gruppo', value : 'group'}]
  },
  {
    key: 'plant',
    label: 'Impianto',
    required : true,
    refs: [{ key:'type', condition: 'eq', value: 'plant'}]
  },
  {
    key: 'group',
    label: 'Gruppo',
    required : true,
    refs: [{ key:'type', condition: 'eq', value: 'group'}]
  },
];

export default crudFields
